import React from 'react';

interface GViewAttachmentProps {
  src: string;
}

const GViewAttachment: React.FC<GViewAttachmentProps> = ({ src }) => {
  if (!src) {
    return null;
  }
  const safeSubUrl = encodeURIComponent(src);
  const gviewUrl = `https://drive.google.com/viewerng/viewer?url=${safeSubUrl}&embedded=true`;

  return <iframe width="100%" height="100%" src={gviewUrl}></iframe>;
};

export default GViewAttachment;
